/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SvatbaTokenRouteImport } from './routes/svatba.$token'
import { Route as AuthWWorkspaceSlugRouteImport } from './routes/_auth/w.$workspaceSlug'
import { Route as SvatbaTokenIndexRouteImport } from './routes/svatba.$token.index'
import { Route as SvatbaTokenDenRouteImport } from './routes/svatba.$token.den'
import { Route as SvatbaPPartyTokenRouteImport } from './routes/svatba.p.$partyToken'
import { Route as AuthWWorkspaceSlugIndexRouteImport } from './routes/_auth/w.$workspaceSlug.index'
import { Route as AuthWWorkspaceSlugAttireRouteImport } from './routes/_auth/w.$workspaceSlug.attire'
import { Route as AuthWWorkspaceSlugBeautyRouteImport } from './routes/_auth/w.$workspaceSlug.beauty'
import { Route as AuthWWorkspaceSlugBudgetRouteImport } from './routes/_auth/w.$workspaceSlug.budget'
import { Route as AuthWWorkspaceSlugCeremonyRouteImport } from './routes/_auth/w.$workspaceSlug.ceremony'
import { Route as AuthWWorkspaceSlugDecorRouteImport } from './routes/_auth/w.$workspaceSlug.decor'
import { Route as AuthWWorkspaceSlugGuestsRouteImport } from './routes/_auth/w.$workspaceSlug.guests'
import { Route as AuthWWorkspaceSlugMusicRouteImport } from './routes/_auth/w.$workspaceSlug.music'
import { Route as AuthWWorkspaceSlugPhotoRouteImport } from './routes/_auth/w.$workspaceSlug.photo'
import { Route as AuthWWorkspaceSlugPlaceRouteImport } from './routes/_auth/w.$workspaceSlug.place'
import { Route as AuthWWorkspaceSlugReceptionRouteImport } from './routes/_auth/w.$workspaceSlug.reception'
import { Route as AuthWWorkspaceSlugScheduleRouteImport } from './routes/_auth/w.$workspaceSlug.schedule'
import { Route as AuthWWorkspaceSlugSuppliersRouteImport } from './routes/_auth/w.$workspaceSlug.suppliers'
import { Route as AuthWWorkspaceSlugTasksRouteImport } from './routes/_auth/w.$workspaceSlug.tasks'
import { Route as AuthWWorkspaceSlugVenuesRouteImport } from './routes/_auth/w.$workspaceSlug.venues'
import { Route as AuthWWorkspaceSlugWebsiteRouteImport } from './routes/_auth/w.$workspaceSlug.website'
import { Route as AuthWWorkspaceSlugWeddingDayRouteImport } from './routes/_auth/w.$workspaceSlug.wedding-day'
import { Route as AuthWWorkspaceSlugSettingsHistoryRouteImport } from './routes/_auth/w.$workspaceSlug.settings.history'
import { Route as AuthWWorkspaceSlugSettingsWeddingRouteImport } from './routes/_auth/w.$workspaceSlug.settings.wedding'
import { Route as AuthWWorkspaceSlugSuppliersIndexRouteImport } from './routes/_auth/w.$workspaceSlug.suppliers.index'
import { Route as AuthWWorkspaceSlugSuppliersWeddingSupplierIdRouteImport } from './routes/_auth/w.$workspaceSlug.suppliers.$weddingSupplierId'
import { Route as AuthWWorkspaceSlugTasksIndexRouteImport } from './routes/_auth/w.$workspaceSlug.tasks.index'
import { Route as AuthWWorkspaceSlugTasksTaskIdRouteImport } from './routes/_auth/w.$workspaceSlug.tasks.$taskId'
import { Route as AuthWWorkspaceSlugVenuesIndexRouteImport } from './routes/_auth/w.$workspaceSlug.venues.index'
import { Route as AuthWWorkspaceSlugVenuesVenueIdRouteImport } from './routes/_auth/w.$workspaceSlug.venues.$venueId'
import { Route as AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRouteImport } from './routes/_auth/w.$workspaceSlug.suppliers.catalog.$catalogSupplierId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const SvatbaTokenRoute = SvatbaTokenRouteImport.update({
  id: '/svatba/$token',
  path: '/svatba/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWWorkspaceSlugRoute = AuthWWorkspaceSlugRouteImport.update({
  id: '/w/$workspaceSlug',
  path: '/w/$workspaceSlug',
  getParentRoute: () => AuthRouteRoute,
} as any)
const SvatbaTokenIndexRoute = SvatbaTokenIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SvatbaTokenRoute,
} as any)
const SvatbaTokenDenRoute = SvatbaTokenDenRouteImport.update({
  id: '/den',
  path: '/den',
  getParentRoute: () => SvatbaTokenRoute,
} as any)
const SvatbaPPartyTokenRoute = SvatbaPPartyTokenRouteImport.update({
  id: '/svatba/p/$partyToken',
  path: '/svatba/p/$partyToken',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthWWorkspaceSlugIndexRoute = AuthWWorkspaceSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugAttireRoute =
  AuthWWorkspaceSlugAttireRouteImport.update({
    id: '/attire',
    path: '/attire',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugBeautyRoute =
  AuthWWorkspaceSlugBeautyRouteImport.update({
    id: '/beauty',
    path: '/beauty',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugBudgetRoute =
  AuthWWorkspaceSlugBudgetRouteImport.update({
    id: '/budget',
    path: '/budget',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugCeremonyRoute =
  AuthWWorkspaceSlugCeremonyRouteImport.update({
    id: '/ceremony',
    path: '/ceremony',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugDecorRoute = AuthWWorkspaceSlugDecorRouteImport.update({
  id: '/decor',
  path: '/decor',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugGuestsRoute =
  AuthWWorkspaceSlugGuestsRouteImport.update({
    id: '/guests',
    path: '/guests',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugMusicRoute = AuthWWorkspaceSlugMusicRouteImport.update({
  id: '/music',
  path: '/music',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugPhotoRoute = AuthWWorkspaceSlugPhotoRouteImport.update({
  id: '/photo',
  path: '/photo',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugPlaceRoute = AuthWWorkspaceSlugPlaceRouteImport.update({
  id: '/place',
  path: '/place',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugReceptionRoute =
  AuthWWorkspaceSlugReceptionRouteImport.update({
    id: '/reception',
    path: '/reception',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugScheduleRoute =
  AuthWWorkspaceSlugScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugSuppliersRoute =
  AuthWWorkspaceSlugSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugTasksRoute = AuthWWorkspaceSlugTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AuthWWorkspaceSlugRoute,
} as any)
const AuthWWorkspaceSlugVenuesRoute =
  AuthWWorkspaceSlugVenuesRouteImport.update({
    id: '/venues',
    path: '/venues',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugWebsiteRoute =
  AuthWWorkspaceSlugWebsiteRouteImport.update({
    id: '/website',
    path: '/website',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugWeddingDayRoute =
  AuthWWorkspaceSlugWeddingDayRouteImport.update({
    id: '/wedding-day',
    path: '/wedding-day',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugSettingsHistoryRoute =
  AuthWWorkspaceSlugSettingsHistoryRouteImport.update({
    id: '/settings/history',
    path: '/settings/history',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugSettingsWeddingRoute =
  AuthWWorkspaceSlugSettingsWeddingRouteImport.update({
    id: '/settings/wedding',
    path: '/settings/wedding',
    getParentRoute: () => AuthWWorkspaceSlugRoute,
  } as any)
const AuthWWorkspaceSlugSuppliersIndexRoute =
  AuthWWorkspaceSlugSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthWWorkspaceSlugSuppliersRoute,
  } as any)
const AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute =
  AuthWWorkspaceSlugSuppliersWeddingSupplierIdRouteImport.update({
    id: '/$weddingSupplierId',
    path: '/$weddingSupplierId',
    getParentRoute: () => AuthWWorkspaceSlugSuppliersRoute,
  } as any)
const AuthWWorkspaceSlugTasksIndexRoute =
  AuthWWorkspaceSlugTasksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthWWorkspaceSlugTasksRoute,
  } as any)
const AuthWWorkspaceSlugTasksTaskIdRoute =
  AuthWWorkspaceSlugTasksTaskIdRouteImport.update({
    id: '/$taskId',
    path: '/$taskId',
    getParentRoute: () => AuthWWorkspaceSlugTasksRoute,
  } as any)
const AuthWWorkspaceSlugVenuesIndexRoute =
  AuthWWorkspaceSlugVenuesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthWWorkspaceSlugVenuesRoute,
  } as any)
const AuthWWorkspaceSlugVenuesVenueIdRoute =
  AuthWWorkspaceSlugVenuesVenueIdRouteImport.update({
    id: '/$venueId',
    path: '/$venueId',
    getParentRoute: () => AuthWWorkspaceSlugVenuesRoute,
  } as any)
const AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute =
  AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRouteImport.update({
    id: '/catalog/$catalogSupplierId',
    path: '/catalog/$catalogSupplierId',
    getParentRoute: () => AuthWWorkspaceSlugSuppliersRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/svatba/$token': typeof SvatbaTokenRouteWithChildren
  '/w/$workspaceSlug': typeof AuthWWorkspaceSlugRouteWithChildren
  '/svatba/$token/den': typeof SvatbaTokenDenRoute
  '/svatba/p/$partyToken': typeof SvatbaPPartyTokenRoute
  '/svatba/$token/': typeof SvatbaTokenIndexRoute
  '/w/$workspaceSlug/attire': typeof AuthWWorkspaceSlugAttireRoute
  '/w/$workspaceSlug/beauty': typeof AuthWWorkspaceSlugBeautyRoute
  '/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/w/$workspaceSlug/ceremony': typeof AuthWWorkspaceSlugCeremonyRoute
  '/w/$workspaceSlug/decor': typeof AuthWWorkspaceSlugDecorRoute
  '/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/w/$workspaceSlug/music': typeof AuthWWorkspaceSlugMusicRoute
  '/w/$workspaceSlug/photo': typeof AuthWWorkspaceSlugPhotoRoute
  '/w/$workspaceSlug/place': typeof AuthWWorkspaceSlugPlaceRoute
  '/w/$workspaceSlug/reception': typeof AuthWWorkspaceSlugReceptionRoute
  '/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersRouteWithChildren
  '/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksRouteWithChildren
  '/w/$workspaceSlug/venues': typeof AuthWWorkspaceSlugVenuesRouteWithChildren
  '/w/$workspaceSlug/website': typeof AuthWWorkspaceSlugWebsiteRoute
  '/w/$workspaceSlug/wedding-day': typeof AuthWWorkspaceSlugWeddingDayRoute
  '/w/$workspaceSlug/': typeof AuthWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/settings/history': typeof AuthWWorkspaceSlugSettingsHistoryRoute
  '/w/$workspaceSlug/settings/wedding': typeof AuthWWorkspaceSlugSettingsWeddingRoute
  '/w/$workspaceSlug/suppliers/$weddingSupplierId': typeof AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute
  '/w/$workspaceSlug/tasks/$taskId': typeof AuthWWorkspaceSlugTasksTaskIdRoute
  '/w/$workspaceSlug/venues/$venueId': typeof AuthWWorkspaceSlugVenuesVenueIdRoute
  '/w/$workspaceSlug/suppliers/': typeof AuthWWorkspaceSlugSuppliersIndexRoute
  '/w/$workspaceSlug/tasks/': typeof AuthWWorkspaceSlugTasksIndexRoute
  '/w/$workspaceSlug/venues/': typeof AuthWWorkspaceSlugVenuesIndexRoute
  '/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId': typeof AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/svatba/$token/den': typeof SvatbaTokenDenRoute
  '/svatba/p/$partyToken': typeof SvatbaPPartyTokenRoute
  '/svatba/$token': typeof SvatbaTokenIndexRoute
  '/w/$workspaceSlug/attire': typeof AuthWWorkspaceSlugAttireRoute
  '/w/$workspaceSlug/beauty': typeof AuthWWorkspaceSlugBeautyRoute
  '/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/w/$workspaceSlug/ceremony': typeof AuthWWorkspaceSlugCeremonyRoute
  '/w/$workspaceSlug/decor': typeof AuthWWorkspaceSlugDecorRoute
  '/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/w/$workspaceSlug/music': typeof AuthWWorkspaceSlugMusicRoute
  '/w/$workspaceSlug/photo': typeof AuthWWorkspaceSlugPhotoRoute
  '/w/$workspaceSlug/place': typeof AuthWWorkspaceSlugPlaceRoute
  '/w/$workspaceSlug/reception': typeof AuthWWorkspaceSlugReceptionRoute
  '/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/w/$workspaceSlug/website': typeof AuthWWorkspaceSlugWebsiteRoute
  '/w/$workspaceSlug/wedding-day': typeof AuthWWorkspaceSlugWeddingDayRoute
  '/w/$workspaceSlug': typeof AuthWWorkspaceSlugIndexRoute
  '/w/$workspaceSlug/settings/history': typeof AuthWWorkspaceSlugSettingsHistoryRoute
  '/w/$workspaceSlug/settings/wedding': typeof AuthWWorkspaceSlugSettingsWeddingRoute
  '/w/$workspaceSlug/suppliers/$weddingSupplierId': typeof AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute
  '/w/$workspaceSlug/tasks/$taskId': typeof AuthWWorkspaceSlugTasksTaskIdRoute
  '/w/$workspaceSlug/venues/$venueId': typeof AuthWWorkspaceSlugVenuesVenueIdRoute
  '/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersIndexRoute
  '/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksIndexRoute
  '/w/$workspaceSlug/venues': typeof AuthWWorkspaceSlugVenuesIndexRoute
  '/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId': typeof AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/signup': typeof SignupRoute
  '/svatba/$token': typeof SvatbaTokenRouteWithChildren
  '/_auth/w/$workspaceSlug': typeof AuthWWorkspaceSlugRouteWithChildren
  '/svatba/$token/den': typeof SvatbaTokenDenRoute
  '/svatba/p/$partyToken': typeof SvatbaPPartyTokenRoute
  '/svatba/$token/': typeof SvatbaTokenIndexRoute
  '/_auth/w/$workspaceSlug/attire': typeof AuthWWorkspaceSlugAttireRoute
  '/_auth/w/$workspaceSlug/beauty': typeof AuthWWorkspaceSlugBeautyRoute
  '/_auth/w/$workspaceSlug/budget': typeof AuthWWorkspaceSlugBudgetRoute
  '/_auth/w/$workspaceSlug/ceremony': typeof AuthWWorkspaceSlugCeremonyRoute
  '/_auth/w/$workspaceSlug/decor': typeof AuthWWorkspaceSlugDecorRoute
  '/_auth/w/$workspaceSlug/guests': typeof AuthWWorkspaceSlugGuestsRoute
  '/_auth/w/$workspaceSlug/music': typeof AuthWWorkspaceSlugMusicRoute
  '/_auth/w/$workspaceSlug/photo': typeof AuthWWorkspaceSlugPhotoRoute
  '/_auth/w/$workspaceSlug/place': typeof AuthWWorkspaceSlugPlaceRoute
  '/_auth/w/$workspaceSlug/reception': typeof AuthWWorkspaceSlugReceptionRoute
  '/_auth/w/$workspaceSlug/schedule': typeof AuthWWorkspaceSlugScheduleRoute
  '/_auth/w/$workspaceSlug/suppliers': typeof AuthWWorkspaceSlugSuppliersRouteWithChildren
  '/_auth/w/$workspaceSlug/tasks': typeof AuthWWorkspaceSlugTasksRouteWithChildren
  '/_auth/w/$workspaceSlug/venues': typeof AuthWWorkspaceSlugVenuesRouteWithChildren
  '/_auth/w/$workspaceSlug/website': typeof AuthWWorkspaceSlugWebsiteRoute
  '/_auth/w/$workspaceSlug/wedding-day': typeof AuthWWorkspaceSlugWeddingDayRoute
  '/_auth/w/$workspaceSlug/': typeof AuthWWorkspaceSlugIndexRoute
  '/_auth/w/$workspaceSlug/settings/history': typeof AuthWWorkspaceSlugSettingsHistoryRoute
  '/_auth/w/$workspaceSlug/settings/wedding': typeof AuthWWorkspaceSlugSettingsWeddingRoute
  '/_auth/w/$workspaceSlug/suppliers/$weddingSupplierId': typeof AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute
  '/_auth/w/$workspaceSlug/tasks/$taskId': typeof AuthWWorkspaceSlugTasksTaskIdRoute
  '/_auth/w/$workspaceSlug/venues/$venueId': typeof AuthWWorkspaceSlugVenuesVenueIdRoute
  '/_auth/w/$workspaceSlug/suppliers/': typeof AuthWWorkspaceSlugSuppliersIndexRoute
  '/_auth/w/$workspaceSlug/tasks/': typeof AuthWWorkspaceSlugTasksIndexRoute
  '/_auth/w/$workspaceSlug/venues/': typeof AuthWWorkspaceSlugVenuesIndexRoute
  '/_auth/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId': typeof AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/signup'
    | '/svatba/$token'
    | '/w/$workspaceSlug'
    | '/svatba/$token/den'
    | '/svatba/p/$partyToken'
    | '/svatba/$token/'
    | '/w/$workspaceSlug/attire'
    | '/w/$workspaceSlug/beauty'
    | '/w/$workspaceSlug/budget'
    | '/w/$workspaceSlug/ceremony'
    | '/w/$workspaceSlug/decor'
    | '/w/$workspaceSlug/guests'
    | '/w/$workspaceSlug/music'
    | '/w/$workspaceSlug/photo'
    | '/w/$workspaceSlug/place'
    | '/w/$workspaceSlug/reception'
    | '/w/$workspaceSlug/schedule'
    | '/w/$workspaceSlug/suppliers'
    | '/w/$workspaceSlug/tasks'
    | '/w/$workspaceSlug/venues'
    | '/w/$workspaceSlug/website'
    | '/w/$workspaceSlug/wedding-day'
    | '/w/$workspaceSlug/'
    | '/w/$workspaceSlug/settings/history'
    | '/w/$workspaceSlug/settings/wedding'
    | '/w/$workspaceSlug/suppliers/$weddingSupplierId'
    | '/w/$workspaceSlug/tasks/$taskId'
    | '/w/$workspaceSlug/venues/$venueId'
    | '/w/$workspaceSlug/suppliers/'
    | '/w/$workspaceSlug/tasks/'
    | '/w/$workspaceSlug/venues/'
    | '/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/signup'
    | '/svatba/$token/den'
    | '/svatba/p/$partyToken'
    | '/svatba/$token'
    | '/w/$workspaceSlug/attire'
    | '/w/$workspaceSlug/beauty'
    | '/w/$workspaceSlug/budget'
    | '/w/$workspaceSlug/ceremony'
    | '/w/$workspaceSlug/decor'
    | '/w/$workspaceSlug/guests'
    | '/w/$workspaceSlug/music'
    | '/w/$workspaceSlug/photo'
    | '/w/$workspaceSlug/place'
    | '/w/$workspaceSlug/reception'
    | '/w/$workspaceSlug/schedule'
    | '/w/$workspaceSlug/website'
    | '/w/$workspaceSlug/wedding-day'
    | '/w/$workspaceSlug'
    | '/w/$workspaceSlug/settings/history'
    | '/w/$workspaceSlug/settings/wedding'
    | '/w/$workspaceSlug/suppliers/$weddingSupplierId'
    | '/w/$workspaceSlug/tasks/$taskId'
    | '/w/$workspaceSlug/venues/$venueId'
    | '/w/$workspaceSlug/suppliers'
    | '/w/$workspaceSlug/tasks'
    | '/w/$workspaceSlug/venues'
    | '/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/signup'
    | '/svatba/$token'
    | '/_auth/w/$workspaceSlug'
    | '/svatba/$token/den'
    | '/svatba/p/$partyToken'
    | '/svatba/$token/'
    | '/_auth/w/$workspaceSlug/attire'
    | '/_auth/w/$workspaceSlug/beauty'
    | '/_auth/w/$workspaceSlug/budget'
    | '/_auth/w/$workspaceSlug/ceremony'
    | '/_auth/w/$workspaceSlug/decor'
    | '/_auth/w/$workspaceSlug/guests'
    | '/_auth/w/$workspaceSlug/music'
    | '/_auth/w/$workspaceSlug/photo'
    | '/_auth/w/$workspaceSlug/place'
    | '/_auth/w/$workspaceSlug/reception'
    | '/_auth/w/$workspaceSlug/schedule'
    | '/_auth/w/$workspaceSlug/suppliers'
    | '/_auth/w/$workspaceSlug/tasks'
    | '/_auth/w/$workspaceSlug/venues'
    | '/_auth/w/$workspaceSlug/website'
    | '/_auth/w/$workspaceSlug/wedding-day'
    | '/_auth/w/$workspaceSlug/'
    | '/_auth/w/$workspaceSlug/settings/history'
    | '/_auth/w/$workspaceSlug/settings/wedding'
    | '/_auth/w/$workspaceSlug/suppliers/$weddingSupplierId'
    | '/_auth/w/$workspaceSlug/tasks/$taskId'
    | '/_auth/w/$workspaceSlug/venues/$venueId'
    | '/_auth/w/$workspaceSlug/suppliers/'
    | '/_auth/w/$workspaceSlug/tasks/'
    | '/_auth/w/$workspaceSlug/venues/'
    | '/_auth/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignupRoute: typeof SignupRoute
  SvatbaTokenRoute: typeof SvatbaTokenRouteWithChildren
  SvatbaPPartyTokenRoute: typeof SvatbaPPartyTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/svatba/$token': {
      id: '/svatba/$token'
      path: '/svatba/$token'
      fullPath: '/svatba/$token'
      preLoaderRoute: typeof SvatbaTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/w/$workspaceSlug': {
      id: '/_auth/w/$workspaceSlug'
      path: '/w/$workspaceSlug'
      fullPath: '/w/$workspaceSlug'
      preLoaderRoute: typeof AuthWWorkspaceSlugRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/svatba/$token/': {
      id: '/svatba/$token/'
      path: '/'
      fullPath: '/svatba/$token/'
      preLoaderRoute: typeof SvatbaTokenIndexRouteImport
      parentRoute: typeof SvatbaTokenRoute
    }
    '/svatba/$token/den': {
      id: '/svatba/$token/den'
      path: '/den'
      fullPath: '/svatba/$token/den'
      preLoaderRoute: typeof SvatbaTokenDenRouteImport
      parentRoute: typeof SvatbaTokenRoute
    }
    '/svatba/p/$partyToken': {
      id: '/svatba/p/$partyToken'
      path: '/svatba/p/$partyToken'
      fullPath: '/svatba/p/$partyToken'
      preLoaderRoute: typeof SvatbaPPartyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/w/$workspaceSlug/': {
      id: '/_auth/w/$workspaceSlug/'
      path: '/'
      fullPath: '/w/$workspaceSlug/'
      preLoaderRoute: typeof AuthWWorkspaceSlugIndexRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/attire': {
      id: '/_auth/w/$workspaceSlug/attire'
      path: '/attire'
      fullPath: '/w/$workspaceSlug/attire'
      preLoaderRoute: typeof AuthWWorkspaceSlugAttireRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/beauty': {
      id: '/_auth/w/$workspaceSlug/beauty'
      path: '/beauty'
      fullPath: '/w/$workspaceSlug/beauty'
      preLoaderRoute: typeof AuthWWorkspaceSlugBeautyRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/budget': {
      id: '/_auth/w/$workspaceSlug/budget'
      path: '/budget'
      fullPath: '/w/$workspaceSlug/budget'
      preLoaderRoute: typeof AuthWWorkspaceSlugBudgetRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/ceremony': {
      id: '/_auth/w/$workspaceSlug/ceremony'
      path: '/ceremony'
      fullPath: '/w/$workspaceSlug/ceremony'
      preLoaderRoute: typeof AuthWWorkspaceSlugCeremonyRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/decor': {
      id: '/_auth/w/$workspaceSlug/decor'
      path: '/decor'
      fullPath: '/w/$workspaceSlug/decor'
      preLoaderRoute: typeof AuthWWorkspaceSlugDecorRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/guests': {
      id: '/_auth/w/$workspaceSlug/guests'
      path: '/guests'
      fullPath: '/w/$workspaceSlug/guests'
      preLoaderRoute: typeof AuthWWorkspaceSlugGuestsRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/music': {
      id: '/_auth/w/$workspaceSlug/music'
      path: '/music'
      fullPath: '/w/$workspaceSlug/music'
      preLoaderRoute: typeof AuthWWorkspaceSlugMusicRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/photo': {
      id: '/_auth/w/$workspaceSlug/photo'
      path: '/photo'
      fullPath: '/w/$workspaceSlug/photo'
      preLoaderRoute: typeof AuthWWorkspaceSlugPhotoRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/place': {
      id: '/_auth/w/$workspaceSlug/place'
      path: '/place'
      fullPath: '/w/$workspaceSlug/place'
      preLoaderRoute: typeof AuthWWorkspaceSlugPlaceRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/reception': {
      id: '/_auth/w/$workspaceSlug/reception'
      path: '/reception'
      fullPath: '/w/$workspaceSlug/reception'
      preLoaderRoute: typeof AuthWWorkspaceSlugReceptionRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/schedule': {
      id: '/_auth/w/$workspaceSlug/schedule'
      path: '/schedule'
      fullPath: '/w/$workspaceSlug/schedule'
      preLoaderRoute: typeof AuthWWorkspaceSlugScheduleRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/suppliers': {
      id: '/_auth/w/$workspaceSlug/suppliers'
      path: '/suppliers'
      fullPath: '/w/$workspaceSlug/suppliers'
      preLoaderRoute: typeof AuthWWorkspaceSlugSuppliersRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/tasks': {
      id: '/_auth/w/$workspaceSlug/tasks'
      path: '/tasks'
      fullPath: '/w/$workspaceSlug/tasks'
      preLoaderRoute: typeof AuthWWorkspaceSlugTasksRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/venues': {
      id: '/_auth/w/$workspaceSlug/venues'
      path: '/venues'
      fullPath: '/w/$workspaceSlug/venues'
      preLoaderRoute: typeof AuthWWorkspaceSlugVenuesRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/website': {
      id: '/_auth/w/$workspaceSlug/website'
      path: '/website'
      fullPath: '/w/$workspaceSlug/website'
      preLoaderRoute: typeof AuthWWorkspaceSlugWebsiteRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/wedding-day': {
      id: '/_auth/w/$workspaceSlug/wedding-day'
      path: '/wedding-day'
      fullPath: '/w/$workspaceSlug/wedding-day'
      preLoaderRoute: typeof AuthWWorkspaceSlugWeddingDayRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/settings/history': {
      id: '/_auth/w/$workspaceSlug/settings/history'
      path: '/settings/history'
      fullPath: '/w/$workspaceSlug/settings/history'
      preLoaderRoute: typeof AuthWWorkspaceSlugSettingsHistoryRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/settings/wedding': {
      id: '/_auth/w/$workspaceSlug/settings/wedding'
      path: '/settings/wedding'
      fullPath: '/w/$workspaceSlug/settings/wedding'
      preLoaderRoute: typeof AuthWWorkspaceSlugSettingsWeddingRouteImport
      parentRoute: typeof AuthWWorkspaceSlugRoute
    }
    '/_auth/w/$workspaceSlug/suppliers/': {
      id: '/_auth/w/$workspaceSlug/suppliers/'
      path: '/'
      fullPath: '/w/$workspaceSlug/suppliers/'
      preLoaderRoute: typeof AuthWWorkspaceSlugSuppliersIndexRouteImport
      parentRoute: typeof AuthWWorkspaceSlugSuppliersRoute
    }
    '/_auth/w/$workspaceSlug/suppliers/$weddingSupplierId': {
      id: '/_auth/w/$workspaceSlug/suppliers/$weddingSupplierId'
      path: '/$weddingSupplierId'
      fullPath: '/w/$workspaceSlug/suppliers/$weddingSupplierId'
      preLoaderRoute: typeof AuthWWorkspaceSlugSuppliersWeddingSupplierIdRouteImport
      parentRoute: typeof AuthWWorkspaceSlugSuppliersRoute
    }
    '/_auth/w/$workspaceSlug/tasks/': {
      id: '/_auth/w/$workspaceSlug/tasks/'
      path: '/'
      fullPath: '/w/$workspaceSlug/tasks/'
      preLoaderRoute: typeof AuthWWorkspaceSlugTasksIndexRouteImport
      parentRoute: typeof AuthWWorkspaceSlugTasksRoute
    }
    '/_auth/w/$workspaceSlug/tasks/$taskId': {
      id: '/_auth/w/$workspaceSlug/tasks/$taskId'
      path: '/$taskId'
      fullPath: '/w/$workspaceSlug/tasks/$taskId'
      preLoaderRoute: typeof AuthWWorkspaceSlugTasksTaskIdRouteImport
      parentRoute: typeof AuthWWorkspaceSlugTasksRoute
    }
    '/_auth/w/$workspaceSlug/venues/': {
      id: '/_auth/w/$workspaceSlug/venues/'
      path: '/'
      fullPath: '/w/$workspaceSlug/venues/'
      preLoaderRoute: typeof AuthWWorkspaceSlugVenuesIndexRouteImport
      parentRoute: typeof AuthWWorkspaceSlugVenuesRoute
    }
    '/_auth/w/$workspaceSlug/venues/$venueId': {
      id: '/_auth/w/$workspaceSlug/venues/$venueId'
      path: '/$venueId'
      fullPath: '/w/$workspaceSlug/venues/$venueId'
      preLoaderRoute: typeof AuthWWorkspaceSlugVenuesVenueIdRouteImport
      parentRoute: typeof AuthWWorkspaceSlugVenuesRoute
    }
    '/_auth/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId': {
      id: '/_auth/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId'
      path: '/catalog/$catalogSupplierId'
      fullPath: '/w/$workspaceSlug/suppliers/catalog/$catalogSupplierId'
      preLoaderRoute: typeof AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRouteImport
      parentRoute: typeof AuthWWorkspaceSlugSuppliersRoute
    }
  }
}

interface AuthWWorkspaceSlugSuppliersRouteChildren {
  AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute: typeof AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute
  AuthWWorkspaceSlugSuppliersIndexRoute: typeof AuthWWorkspaceSlugSuppliersIndexRoute
  AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute: typeof AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute
}

const AuthWWorkspaceSlugSuppliersRouteChildren: AuthWWorkspaceSlugSuppliersRouteChildren =
  {
    AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute:
      AuthWWorkspaceSlugSuppliersWeddingSupplierIdRoute,
    AuthWWorkspaceSlugSuppliersIndexRoute:
      AuthWWorkspaceSlugSuppliersIndexRoute,
    AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute:
      AuthWWorkspaceSlugSuppliersCatalogCatalogSupplierIdRoute,
  }

const AuthWWorkspaceSlugSuppliersRouteWithChildren =
  AuthWWorkspaceSlugSuppliersRoute._addFileChildren(
    AuthWWorkspaceSlugSuppliersRouteChildren,
  )

interface AuthWWorkspaceSlugTasksRouteChildren {
  AuthWWorkspaceSlugTasksTaskIdRoute: typeof AuthWWorkspaceSlugTasksTaskIdRoute
  AuthWWorkspaceSlugTasksIndexRoute: typeof AuthWWorkspaceSlugTasksIndexRoute
}

const AuthWWorkspaceSlugTasksRouteChildren: AuthWWorkspaceSlugTasksRouteChildren =
  {
    AuthWWorkspaceSlugTasksTaskIdRoute: AuthWWorkspaceSlugTasksTaskIdRoute,
    AuthWWorkspaceSlugTasksIndexRoute: AuthWWorkspaceSlugTasksIndexRoute,
  }

const AuthWWorkspaceSlugTasksRouteWithChildren =
  AuthWWorkspaceSlugTasksRoute._addFileChildren(
    AuthWWorkspaceSlugTasksRouteChildren,
  )

interface AuthWWorkspaceSlugVenuesRouteChildren {
  AuthWWorkspaceSlugVenuesVenueIdRoute: typeof AuthWWorkspaceSlugVenuesVenueIdRoute
  AuthWWorkspaceSlugVenuesIndexRoute: typeof AuthWWorkspaceSlugVenuesIndexRoute
}

const AuthWWorkspaceSlugVenuesRouteChildren: AuthWWorkspaceSlugVenuesRouteChildren =
  {
    AuthWWorkspaceSlugVenuesVenueIdRoute: AuthWWorkspaceSlugVenuesVenueIdRoute,
    AuthWWorkspaceSlugVenuesIndexRoute: AuthWWorkspaceSlugVenuesIndexRoute,
  }

const AuthWWorkspaceSlugVenuesRouteWithChildren =
  AuthWWorkspaceSlugVenuesRoute._addFileChildren(
    AuthWWorkspaceSlugVenuesRouteChildren,
  )

interface AuthWWorkspaceSlugRouteChildren {
  AuthWWorkspaceSlugAttireRoute: typeof AuthWWorkspaceSlugAttireRoute
  AuthWWorkspaceSlugBeautyRoute: typeof AuthWWorkspaceSlugBeautyRoute
  AuthWWorkspaceSlugBudgetRoute: typeof AuthWWorkspaceSlugBudgetRoute
  AuthWWorkspaceSlugCeremonyRoute: typeof AuthWWorkspaceSlugCeremonyRoute
  AuthWWorkspaceSlugDecorRoute: typeof AuthWWorkspaceSlugDecorRoute
  AuthWWorkspaceSlugGuestsRoute: typeof AuthWWorkspaceSlugGuestsRoute
  AuthWWorkspaceSlugMusicRoute: typeof AuthWWorkspaceSlugMusicRoute
  AuthWWorkspaceSlugPhotoRoute: typeof AuthWWorkspaceSlugPhotoRoute
  AuthWWorkspaceSlugPlaceRoute: typeof AuthWWorkspaceSlugPlaceRoute
  AuthWWorkspaceSlugReceptionRoute: typeof AuthWWorkspaceSlugReceptionRoute
  AuthWWorkspaceSlugScheduleRoute: typeof AuthWWorkspaceSlugScheduleRoute
  AuthWWorkspaceSlugSuppliersRoute: typeof AuthWWorkspaceSlugSuppliersRouteWithChildren
  AuthWWorkspaceSlugTasksRoute: typeof AuthWWorkspaceSlugTasksRouteWithChildren
  AuthWWorkspaceSlugVenuesRoute: typeof AuthWWorkspaceSlugVenuesRouteWithChildren
  AuthWWorkspaceSlugWebsiteRoute: typeof AuthWWorkspaceSlugWebsiteRoute
  AuthWWorkspaceSlugWeddingDayRoute: typeof AuthWWorkspaceSlugWeddingDayRoute
  AuthWWorkspaceSlugIndexRoute: typeof AuthWWorkspaceSlugIndexRoute
  AuthWWorkspaceSlugSettingsHistoryRoute: typeof AuthWWorkspaceSlugSettingsHistoryRoute
  AuthWWorkspaceSlugSettingsWeddingRoute: typeof AuthWWorkspaceSlugSettingsWeddingRoute
}

const AuthWWorkspaceSlugRouteChildren: AuthWWorkspaceSlugRouteChildren = {
  AuthWWorkspaceSlugAttireRoute: AuthWWorkspaceSlugAttireRoute,
  AuthWWorkspaceSlugBeautyRoute: AuthWWorkspaceSlugBeautyRoute,
  AuthWWorkspaceSlugBudgetRoute: AuthWWorkspaceSlugBudgetRoute,
  AuthWWorkspaceSlugCeremonyRoute: AuthWWorkspaceSlugCeremonyRoute,
  AuthWWorkspaceSlugDecorRoute: AuthWWorkspaceSlugDecorRoute,
  AuthWWorkspaceSlugGuestsRoute: AuthWWorkspaceSlugGuestsRoute,
  AuthWWorkspaceSlugMusicRoute: AuthWWorkspaceSlugMusicRoute,
  AuthWWorkspaceSlugPhotoRoute: AuthWWorkspaceSlugPhotoRoute,
  AuthWWorkspaceSlugPlaceRoute: AuthWWorkspaceSlugPlaceRoute,
  AuthWWorkspaceSlugReceptionRoute: AuthWWorkspaceSlugReceptionRoute,
  AuthWWorkspaceSlugScheduleRoute: AuthWWorkspaceSlugScheduleRoute,
  AuthWWorkspaceSlugSuppliersRoute:
    AuthWWorkspaceSlugSuppliersRouteWithChildren,
  AuthWWorkspaceSlugTasksRoute: AuthWWorkspaceSlugTasksRouteWithChildren,
  AuthWWorkspaceSlugVenuesRoute: AuthWWorkspaceSlugVenuesRouteWithChildren,
  AuthWWorkspaceSlugWebsiteRoute: AuthWWorkspaceSlugWebsiteRoute,
  AuthWWorkspaceSlugWeddingDayRoute: AuthWWorkspaceSlugWeddingDayRoute,
  AuthWWorkspaceSlugIndexRoute: AuthWWorkspaceSlugIndexRoute,
  AuthWWorkspaceSlugSettingsHistoryRoute:
    AuthWWorkspaceSlugSettingsHistoryRoute,
  AuthWWorkspaceSlugSettingsWeddingRoute:
    AuthWWorkspaceSlugSettingsWeddingRoute,
}

const AuthWWorkspaceSlugRouteWithChildren =
  AuthWWorkspaceSlugRoute._addFileChildren(AuthWWorkspaceSlugRouteChildren)

interface AuthRouteRouteChildren {
  AuthWWorkspaceSlugRoute: typeof AuthWWorkspaceSlugRouteWithChildren
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthWWorkspaceSlugRoute: AuthWWorkspaceSlugRouteWithChildren,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface SvatbaTokenRouteChildren {
  SvatbaTokenDenRoute: typeof SvatbaTokenDenRoute
  SvatbaTokenIndexRoute: typeof SvatbaTokenIndexRoute
}

const SvatbaTokenRouteChildren: SvatbaTokenRouteChildren = {
  SvatbaTokenDenRoute: SvatbaTokenDenRoute,
  SvatbaTokenIndexRoute: SvatbaTokenIndexRoute,
}

const SvatbaTokenRouteWithChildren = SvatbaTokenRoute._addFileChildren(
  SvatbaTokenRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  LoginRoute: LoginRoute,
  SignupRoute: SignupRoute,
  SvatbaTokenRoute: SvatbaTokenRouteWithChildren,
  SvatbaPPartyTokenRoute: SvatbaPPartyTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
